export default [
  {
    title: "PDPA",
    customIcon: "PdpaSvg",
    children: [
      {
        title: 'Consent Form',
        children : [
          {
            title: 'Sub Consent',
            route: "pdpa-list",
            path: "/pdpa/list"
          },
          {
            title: 'Flag',
          }
        ]
      },
      {
        title: 'Form Group',
      },
    ],
  },
];
